module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D13-clean-77c5bd4bdf64906aec7516c7e75b3c24.png";